import { render, staticRenderFns } from "./ZiyaratManagement.vue?vue&type=template&id=c0e05a6a&"
import script from "./ZiyaratManagement.vue?vue&type=script&lang=js&"
export * from "./ZiyaratManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports